import React from 'react';

export const TraderAppealResponse: React.FC<{
    response: { trader_requested_amount?: number | null; trader_response_description?: string | null };
    currency?: string;
}> = ({ response, currency }) => <>
    {response.trader_requested_amount != null && (
        <div className="space-y-1">
            <p className="font-medium">Запрос перерасчёта</p>
            <p>Предложенная сумма: <strong>{response.trader_requested_amount.toLocaleString('ru-RU', { maximumFractionDigits: 6 })} {currency}</strong></p>
        </div>
    )}
    {response.trader_response_description && <p className="text-sm whitespace-pre-wrap">{response.trader_response_description}</p>}
</>;
